import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, NgZone } from '@angular/core';
import { ServicesService } from '../../services/services.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import swal from 'sweetalert2';
import Stepper from 'bs-stepper';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MapsAPILoader } from '@agm/core';

@Component({
  selector: 'app-client-details',
  templateUrl: './client-details.component.html',
  styleUrls: ['./client-details.component.css']
})
export class ClientDetailsComponent implements OnInit {
  cid: any;
  addClientForm: FormGroup;
  activeCat = [];
  constructor(private route: ActivatedRoute, private router: Router,
    private _services: ServicesService, private formBuilder: FormBuilder,
    private modalService: NgbModal, private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
  ) {
    this.route.queryParams.subscribe(params => {
      this.cid = params['cid'];
    });
  }
  backDiv = false;
  isFormSubmitted = false;
  showloader = false;
  countryDropdownSettings: any = {};
  countryList = [];


  stepper1Node;
  stepper1;
  addProjectOrderForm: FormGroup;
  addMaintenanceOrderForm: FormGroup;
  employeeList = [];
  mapTitle: string;
  closeResult: string;
  mapFor: string;

  deliveryDetails: Object = {};
  routeLocation: string;
  public latitude: number;
  public longitude: number;
  public zoom: number;
  public formatted_address: string;
  public dataToSend: Object = {};
  requestedMap: string;


  ngOnInit() {
    this.stepper1 = new Stepper(document.querySelector('#stepper1'));
    this.stepper1Node = document.querySelector('#stepper1');
    this.stepper1Node.addEventListener('show.bs-stepper', function (event) {
      console.warn('show.bs-stepper', event);
    });
    this.stepper1Node.addEventListener('shown.bs-stepper', function (event) {
      console.warn('shown.bs-stepper', event);
    });

    this.addProjectOrderForm = new FormGroup({
      'project_name': new FormControl('', [Validators.required]),
      'address': new FormControl('', [Validators.required]),
      'project_commencement_date': new FormControl('', [Validators.required])
    });
    this.addMaintenanceOrderForm = new FormGroup({
      'municipality': new FormControl('', [Validators.required]),
      // 'ward': new FormControl('', [Validators.required]),
      'center_name': new FormControl('', [Validators.required]),
      'project_type': new FormControl('', [Validators.required]),
      'description': new FormControl('', [Validators.required]),
      'address': new FormControl('', [Validators.required]),
      'employee': new FormControl('', [Validators.required])
    });

    this.activeCat[1] = true;
    this.clientDropDownFun();

    this.addClientForm = this.formBuilder.group({
      client_name: ['', [Validators.required, Validators.minLength(3)]],
      email_id: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      address: ['', [Validators.required, Validators.minLength(6)]],
      detail: ['', [Validators.required, Validators.minLength(8)]],
      country: ['', [Validators.required]],
      vat_no: ['']
    });

    if (this.cid != undefined) {
      this.backDiv = true;
    }

    this._services.getRequestNoToken('get-countries').subscribe((data: any) => {
      this.countryList = data;
    });

    this.routePath = 'get-employee-names'; // it also update project order
    this._services.requestCreator(this.addMaintenanceOrderForm.value, this.routePath, this._services.getToken()).subscribe((data: any) => {
      this._services.checkToken(data.status);
      if (data.status == '200') {
        this.employeeList = data.result;
      }
    }
    );
  }
  get f() { return this.addClientForm.controls; }

  onItemSelectCountry(item: any) {
    //console.log(item);
  }
  click() {
    this.stepper1.next();
  }

  addClient() {

    this.showloader = true;
    this.isFormSubmitted = true;
    if (this.addClientForm.status != 'VALID') {
      this.showloader = false;
      //this.isFormSubmitted=false;
      return false;
    }
    this._services.requestCreator(this.addClientForm.value, 'add-client', this._services.getToken()).subscribe((data: any) => {
      this._services.checkToken(data.status);
      if (data.status == '200') {
        this.showloader = false;
        this.isFormSubmitted = false;
        swal({
          title: 'Client Add Successfully',
          text: 'You Successfully Added Client',
          type: 'success',
          showCancelButton: false,
          confirmButtonColor: 'rgb(17, 205, 239)',
          cancelButtonColor: 'rgb(245, 54, 92)',
          confirmButtonText: 'Yes'
        }).then(() => {
          this.addClientForm.reset();
          this.stepper1.next();


        });
      } else {
        swal({
          title: 'Create Client Fail',
          text: data.message,
          type: 'error',
          showCancelButton: false,
          confirmButtonColor: 'rgb(17, 205, 239)',
          cancelButtonColor: 'rgb(245, 54, 92)',
          confirmButtonText: 'Yes'
        });
        this.showloader = false;
        this.isFormSubmitted = false;
      }
    },
      (err: HttpErrorResponse) => {
      }
    );
  }

  resetClientForm() {
    this.addClientForm.reset();
  }

  clientDropDownFun() {

    this.countryDropdownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'country_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      closeDropDownOnSelection: true,
      itemsShowLimit: 1,
      allowSearchFilter: true,
      noDataAvailablePlaceholderText: 'No Country Found',
    };
  }

  setCss(id) {
    //console.log(id);
    for (let i = 1; i < 9; i++) {
      this.activeCat[i] = false;
    }
    this.activeCat[id] = true;
  }

  routePath: string;
  listData: any;
  getPageRequest() {
    this.routePath = 'get-client-info';
    let data = {
    };
    const token = localStorage.getItem('userToken');
    this._services.requestCreator(data, this.routePath, token).subscribe((result: any) => {
      this.listData = [];
      this.listData = result.result;
      return true;
    });
  }


  addOrderProject() {
    this.isFormSubmitted = true;
    //console.log(this.addProjectOrderForm);
    this.showloader = true;

    //It will not allow to submit form until all input's filled.
    if (this.addProjectOrderForm.status != 'VALID') {
      this.showloader = false;
      this.isFormSubmitted = false;
      return false;
    }

    this.routePath = 'create-project-order';
    this._services.requestCreator(this.addProjectOrderForm.value, this.routePath, this._services.getToken()).subscribe((data: any) => {
      this._services.checkToken(data.status);
      if (data.status == '200') {
        this.showloader = false;
        this.isFormSubmitted = false;
        swal({
          title: 'Project',
          text: 'Project Added Successfully',
          type: 'success',
          showCancelButton: false,
          confirmButtonColor: 'rgb(17, 205, 239)',
          cancelButtonColor: 'rgb(245, 54, 92)',
          confirmButtonText: 'Yes'
        }).then(() => {
          this.resetProjectOrderForm();
          this.stepper1.next();
        });
      } else {
        this.showloader = false;
        this.isFormSubmitted = false;
      }
    }
    );
  }

  resetProjectOrderForm() {
    this.addProjectOrderForm.reset();
  }

  // maintenance


  open(content, event) {
    this.modalService.open(content).result.then((result) => {

      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    this.mapTitle = 'Select your area';

    /*-----------------Get clicked element---------------*/
    let target = event.target || event.srcElement || event.currentTarget;
    let idAttr = target.attributes.id;
    let value = idAttr.nodeValue;
    // //console.log(this.addMaintenanceOrderForm.controls.address.value);
    this.routeLocation = this.addMaintenanceOrderForm.controls.address.value;

    // this.routeLocation = this.deliveryDetails['delivery-address'];
    this.mapFor = value;
    this.requestedMap = (this.mapFor == 'delivery-address-map') ? 'delivery-address' : 'source';
    //console.log("requestedMap",this.requestedMap);

    //console.log(this.routeLocation);
    this.geoCodeAddress(this.routeLocation);

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }



  geoCodeAddress(address) {

    this.mapsAPILoader.load().then(() => {

      let geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: address }, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {

          //map.setCenter(results[0].geometry.location);
          ////console.log(results[0].geometry.location);

          this.ngZone.run(() => {
            this.setLocation(results[0]);
          });

          this.latitude = results[0].geometry.location.lat();
          this.longitude = results[0].geometry.location.lng();
          this.zoom = 12;
          // //console.log(this.latitude +', '+this.longitude);


        } else {
          //console.log('Geocode was not successful for the following reason: ' + status);
        }
      });
    });
  }

  setLocation(place) {
    this.latitude = place.geometry.location.lat();
    this.longitude = place.geometry.location.lng();
    this.formatted_address = place.formatted_address;

    // //console.log(this.latitude + '----------' + this.longitude);

    let latlng = { lat: <number>(this.latitude), lng: <number>(this.longitude) };
    this.deliveryDetails[this.requestedMap + 'LatLong'] = this.latitude + ', ' + this.longitude;

    this.geoCodeLatLng(latlng);
  }

  geoCodeLatLng(latlng) {
    ////console.log(latlng);
    this.mapsAPILoader.load().then(() => {

      let geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'location': latlng }, (results, status) => {
        if (results[0]) {
          // this.deliveryDetails[this.requestedMap] = results[0].formatted_address;
          this.addMaintenanceOrderForm.patchValue({
            address: results[0].formatted_address
          });

        }
        ////console.log(this.requestedMap);
        ////console.log(this.deliveryDetails[this.requestedMap]);
      });
    });
  }


  addMaintenanceProject() {
    this.isFormSubmitted = true;
    //console.log(this.addMaintenanceOrderForm);
    this.showloader = true;

    //It will not allow to submit form until all input's filled.
    if (this.addMaintenanceOrderForm.status != 'VALID') {
      this.showloader = false;
      this.isFormSubmitted = false;
      return false;
    }

    this.routePath = 'create-maintenance';
    this._services.requestCreator(this.addMaintenanceOrderForm.value, this.routePath, this._services.getToken()).subscribe((data: any) => {
      this._services.checkToken(data.status);
      if (data.status == '200') {
        this.showloader = false;
        this.isFormSubmitted = false;
        swal({
          title: 'Maintenance',
          text: 'Maintenance Added Successfully',
          type: 'success',
          showCancelButton: false,
          confirmButtonColor: 'rgb(17, 205, 239)',
          cancelButtonColor: 'rgb(245, 54, 92)',
          confirmButtonText: 'Yes'
        }).then(() => {
          this.resetProjectOrderForm();
        });
      } else {
        this.showloader = false;
        this.isFormSubmitted = false;
      }
    }
    );
  }

  resetMaintenanceProjectForm() {
    this.addMaintenanceOrderForm.reset();
  }





  // Get Target Element
  getElement(event, valueFor) {
    //console.log(valueFor)
    let element = event.target || event.srcElement || event.currentTarget;

    //this.searchPlaces(element, valueFor);
    this.requestedMap = valueFor;
  }

  mapClicked($event: MouseEvent) {
    /*
     this.markers.push({
     lat: $event.coords.lat,
     lng: $event.coords.lng,
     draggable: true
     });
     */

    this.markerMoved($event);


  }

  markerMoved(e) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'location': e.coords },
      (res, status) => {
        if (status === google.maps.GeocoderStatus.OK && res.length) { this.ngZone.run(() => this.setLocation(res[0])); }
      });
  }






  setMapForLocation(address) {
    this.mapsAPILoader.load().then(() => {

      let geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'address': address }, (results, status) => {
        this.deliveryDetails[this.requestedMap + 'LatLong'] = results[0].geometry.location.lat() + ', ' + results[0].geometry.location.lng();
        ////console.log(this.deliveryDetails[this.requestedMap+'LatLong']);
      });
    });
  }

  searchPlaces(e, valueFor) {
    this.mapsAPILoader.load().then(() => {
      const deliveryAddressAutocomplete = new google.maps.places.Autocomplete(e, {
        types: ['address'],
        componentRestrictions: { country: 'in' }
      });

      ////console.log(deliveryAddressAutocomplete);
      //---------------------------load Places Autocomplete-----------
      deliveryAddressAutocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          //get the place result
          const place: google.maps.places.PlaceResult = deliveryAddressAutocomplete.getPlace();
          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.formatted_address = place.formatted_address;
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;

          this.deliveryDetails[valueFor] = place.formatted_address;
          this.deliveryDetails[valueFor + 'LatLong'] = this.latitude + ', ' + this.longitude;
        });
      });
    });
  }

  private setCurrentPosition() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        //console.log(position);
        //this.zoom = 14;
      });
    }
  }

  dir = undefined;
  options = {
    suppressMarkers: true,
    draggable: true,
    travelMode: 'DRIVING',
  };
  /*----------------------------------Google API--------------------------------*/



  initializeMap() {
    this.zoom = 10;
    this.latitude = -25.717530;
    this.longitude = 28.031360;
  }

}
